import React from 'react';
import Layout from '../../components/Layout/Layout';
import DiscoverSubCategories from '../../components/DiscoverSubCategories/DiscoverSubCategories';
import styles from './DiscoverSubCategoriesPage.module.css';

const DiscoverSubCategoriesPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.discoverSubCategoriesStack}>
        <DiscoverSubCategories
          componentSize="Desktop 1440"
          selectedCategoryId={9}
          excludeCardId=""
        />
      </div>
    </Layout>
  );
};

export default DiscoverSubCategoriesPage;